/**
 * 标准单对象界面对应的水印配置
 * PASS: #109557: 绿色-success
 * PROCESS: #EC6E00: 黄色-warn
 * FAIL: #685E6D: 灰色-void
 * REJECT: #FF0026: 红色-error（默认）
 */
export default {
  allocated: {
    text: '待分配',
    type: 'PROCESS',
    color: '#EC6E00'
  },
  submit: {
    text: '已提交',
    type: 'PASS',
    color: '#109557'
  },
  back: {
    text: '已退回',
    type: 'REJECT',
    color: '#FF0026'
  },
  confirm: {
    text: '已确认',
    type: 'PASS',
    color: '#109557'
  },
  system: {
    text: '系统',
    type: 'PASS',
    color: '#109557'
  },
  void: {
    text: t('已作废'),
    type: 'FAIL',
    color: '#685E6D'
  },
  execute: {
    text: '已执行',
    type: 'PASS',
    color: '#109557'
  },
  send: {
    text: '已发出',
    type: 'PASS',
    color: '#109557'
  },
  accepet: {
    text: '已验收',
    type: 'PASS',
    color: '#109557'
  },
  checked: {
    text: '已审核',
    type: 'PASS',
    color: '#109557'
  },
  charge: {
    text: '已记账',
    type: 'PASS',
    color: '#109557'
  },
  Inventory: {
    text: t('已盈亏'),
    type: 'PASS',
    color: '#109557'
  },
  terminate: {
    text: '已终止',
    type: 'PASS',
    color: '#109557'
  },
  extremely: {
    text: t('分货退货数量'),
    type: 'PASS',
    color: '#109557'
  },
  executing: {
    text: '执行中',
    type: 'PASS',
    color: '#109557'
  },
  completed: {
    text: t('已完成'),
    type: 'PASS',
    color: '#109557'
  },
  check: {
    text: '已收银',
    type: 'PASS',
    color: '#109557'
  },
  caseClosed: {
    text: '已中止',
    type: 'PASS',
    color: '#109557'
  },
  out_part_in: {
    text: '出库完成部分入库',
    color: '#109557',
  },
  part_out_part_in: {
    text: '部分出库部分入库',
    color: '#109557',
  },
  part_out_not_in: {
    text: '部分出库未入库',
    color: '#109557',
  },
  part_out: {
    text: '部分出库',
    type: 'PASS',
    color: '#109557'
  },
  part_in: {
    text: '部分入库',
    type: 'PASS',
    color: '#109557'
  },
  out_not_in: {
    text: '出库完成未入库',
    color: '#109557',
  },
  out_in: {
    text: '出库完成入库完成',
    color: '#109557',
  },
  out: {
    text: '出库完成',
    type: 'PASS',
    color: '#109557'
  },
  check_not_out: {
    text: '已审核未出库',
    color: '#109557',
  },
  check_not_enter: {
    text: '已审核未入库',
    color: '#109557',
  },
  check_not_in: {
    text: '已审核未入库',
    color: '#109557',
  },
  boxing: {
    text: '装箱中',
    color: '#4bcd61'
  },
  box: {
    text: '已装箱',
    type: 'PASS',
    color: '#109557'
  },
  confirmed_receipt: {
    text: '已确认收货',
    type: 'PASS',
    color: '#109557'
  },
  create: {
    text: '创建',
    type: 'PASS',
    color: '#109557'
  },
  finish_receiptgoods: {
    text: '收货完成',
    type: 'PASS',
    color: '#109557'
  },
  finish_sendgoods: {
    text: '发货完成',
    type: 'PASS',
    color: '#109557'
  },
  no_confirm: {
    text: '未确认',
    type: 'PASS',
    color: '#109557'
  },
  part_receiptgoods: {
    text: '部分收货',
    type: 'PASS',
    color: '#109557'
  },
  part_sendgoods: {
    text: '部分发货',
    type: 'PASS',
    color: '#109557'
  },
  platform_delivery: {
    text: '平台发货',
    type: 'PASS',
    color: '#109557'
  },
  pre_sale_delivery: {
    text: '预售待发货',
    type: 'PASS',
    color: '#109557'
  },
  pre_sale_shortage: {
    text: '预售缺货',
    type: 'PASS',
    color: '#109557'
  },
  preparing: {
    text: '配货中',
    type: 'PASS',
    color: '#109557'
  },
  sale_shortage: {
    text: '缺货',
    type: 'PASS',
    color: '#109557'
  },
  system_cancel: {
    text: '系统作废',
    type: 'FAIL',
    color: '#685E6D'
  },
  trade_finish: {
    text: '交易完成',
    type: 'PASS',
    color: '#109557'
  },
  unfinished: {
    text: '未完结',
    type: 'PASS',
    color: '#109557'
  },
  update: {
    text: '更新',
    type: 'PASS',
    color: '#109557'
  },
  wait_instock: {
    text: '待入库',
    type: 'PASS',
    color: '#109557'
  },
  wait_outstock: {
    text: '待出库',
    type: 'PASS',
    color: '#109557'
  },
  wait_return_warehouse: {
    text: '等待退货入库',
    color: '#109557',
  },
  wait_saled_audit: {
    text: '等待售后审核',
    color: '#109557',
  },
  waitBill: {
    text: '待开票',
    type: 'PASS',
    color: '#109557'
  },
  warehouse_delivery: {
    text: '仓库发货',
    color: '#109557',
  },
  unchecked: {
    text: '未审核',
    type: 'PASS',
    color: '#109557'
  },
  canceled: {
    text: '已取消',
    type: 'PASS',
    color: '#109557'
  },
  systemCancel: {
    text: '系统作废',
    type: 'FAIL',
    color: '#685E6D'
  },
  finish: {
    text: '完成',
    type: 'PASS',
    color: '#109557'
  },
  ended: {
    text: '已完结',
    type: 'PASS',
    color: '#109557'
  },
  finishInstock: {
    text: '入库完成',
    type: 'PASS',
    color: '#109557'
  },
  finishSendgoods: {
    text: '财务发货完成审核中',
    color: '#109557',
  },
  custAutid: {
    text: '已客审',
    type: 'PASS',
    color: '#109557'
  },
  financeAudit: {
    text: '已财审',
    type: 'PASS',
    color: '#109557'
  },
  delayBill: {
    text: '暂缓开票',
    type: 'PASS',
    color: '#109557'
  },
  finallyBill: {
    text: '已开票',
    type: 'PASS',
    color: '#109557'
  },

  financialAudit: {
    text: '财务审核中',
    type: 'PASS',
    color: '#109557'
  },
  financialMaintain: {
    text: ' 财务维护中',
    type: 'PASS',
    color: '#109557'
  },
  tobeConfirmed: {
    text: '待确认',
    type: 'PASS',
    color: '#109557'
  },
  refuseto: {
    text: '拒回',
    type: 'PASS',
    color: '#109557'
  },
  ProcessCompletion: {
    text: '流程完成',
    type: 'PASS',
    color: '#109557'
  },
  suporting: {
    text: '支持中',
    type: 'PASS',
    color: '#109557'
  },
  leave: {
    text: '已离职',
    type: 'PASS',
    color: '#109557'
  },
  freeze_submit_one: {
    text: '已提交未解冻',
    type: 'PASS',
    color: '#109557'
  },
  freeze_submit_two: {
    text: '已提交部分解冻',
    type: 'PASS',
    color: '#109557'
  },
  freeze_submit_three: {
    text: '全部解冻',
    type: 'PASS',
    color: '#109557'
  },
  audited_not_confirm: {
    text: '已审核未确认',
    type: 'PASS',
    color: '#109557'
  },
  confirm_not_out: {
    text: '已确认未出库',
    type: 'PASS',
    color: '#109557'
  },
  all_submit: {
    text: '全部提交',
    type: 'PASS',
    color: '#109557'
  },
  part_submit: {
    text: '部分提交',
    type: 'PASS',
    color: '#109557'
  },
  submit_confirm: {
    text: '已审核已确认',
    color: '#109557',
  },
  fallback: {
    text: '回退中',
    color: '#109557',
  },
  disconnected: {
    text: '已断联',
    color: '#109557',
  },
  to_be_reviewed: {
    text: '待审核',
    color: '#109557',
  },
  audit: {
    text: '审核中',
    color: '#109557',
  },
  search_source: {
    text: '寻源中',
    color: '#109557',
  },
  await_search_source: {
    text: '待寻源',
    color: '#109557',
  },
  occupancy_section: {
    text: '部分占单',
    color: '#109557',
  },
  occupancy_success: {
    text: '占单成功',
    color: '#109557',
  },
  closed_case: {
    text: '已结案',
    color: '#109557',
  },
};
